export default __webpack_public_path__ + "static/media/ScreambearEmpty.a54b652e.gif";